import { useAtomData } from '@lighthouse/shared'
import React, { useCallback, useDeferredValue, useMemo } from 'react'

import { selectedBlockCustomViewAtom, selectedBlockFormContainerAtom } from '@/atoms/page/state'
import { useCurrentAppId, useCurrentEnvId } from '@/hooks/useApplication'
import { useDataSourceList } from '@/hooks/useDataSource'

import { FieldInputSetting } from '../Common/FieldInputSetting'

interface BlockFieldSettingsProps {
    id: string
    pointer: string
}

const BlockFieldSettings: React.FunctionComponent<BlockFieldSettingsProps> = ({ id: blockId, pointer: pageDsId }) => {
    const currentAppId = useCurrentAppId()
    const envId = useCurrentEnvId()
    const parentForm = useAtomData(selectedBlockFormContainerAtom)

    const mode = useMemo(() => (parentForm ? 'form' : 'field'), [parentForm])

    const customViewDsId = useDeferredValue(
        useAtomData(
            selectedBlockCustomViewAtom,
            useCallback(s => s?.config.pointer, [])
        )
    )

    const pointer = (mode === 'form' ? parentForm?.config.pointer : customViewDsId || pageDsId) ?? ''

    const dataSourceList = useDataSourceList(currentAppId, envId)

    return <FieldInputSetting dataSourceList={dataSourceList} id={blockId} mode={mode} pointer={pointer} />
}

export default BlockFieldSettings
